import React, { type ReactElement, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CircularProgress, Typography } from '@mui/material'
import backgroundGraphics from 'assets/backgroundGraphics.svg'
import { BUTTON_SIZE, BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import ThemeButton from 'common/ui/theme-button'
import { StoreStatus } from 'common/utils/types'

import { activateVendor } from '../auth.service'

import styles from './Activation.module.scss'

const Activation: React.FC = (): ReactElement => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const { activateVendorStatus } = useAppSelector((state) => state.auth)
  const activationData = {
    email: decodeURIComponent(searchParams.get('email') ?? ''),
    token: searchParams.get('token') ?? '',
  }

  useEffect(() => {
    if (activationData.email && activationData.token) {
      void dispatch(activateVendor(activationData))
    }
  }, [])

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${backgroundGraphics})`,
        backgroundPosition: 'left',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
      }}
    >
      <div className={styles.textContainer}>
        <p className={styles.text}>
          Dobrodošli na <b>CDT Vendors</b> platformu
        </p>
      </div>
      {(activateVendorStatus === StoreStatus.Loading || activateVendorStatus === StoreStatus.Idle) && (
        <div className={styles.cardBig}>
          <Typography variant="description4">Aktivacija naloga je u toku.</Typography>
          <CircularProgress />
        </div>
      )}
      {activateVendorStatus === StoreStatus.Succeeded && (
        <div className={styles.cardBig}>
          <Typography variant="description4">Uspešno ste aktivirali svoj nalog.</Typography>
          <ThemeButton
            variant={BUTTON_VARIANTS.secondary}
            size={BUTTON_SIZE.small}
            onClick={() => {
              navigate('/profil')
            }}
          >
            OK
          </ThemeButton>
        </div>
      )}
      {activateVendorStatus === StoreStatus.Failed && (
        <div className={styles.cardBig}>
          <Typography variant="description4">Neuspešna aktivacija naloga.</Typography>
        </div>
      )}
    </div>
  )
}

export default Activation
